<template>
  <div>
    <v-toolbar
      v-if="!laborer"
      flat
      color="white"
      class="mx-0 px-0"
    >
      <v-spacer />
      <v-btn
        color="success"
        rounded
        title="Добавить соискателя"
        @click="onEnableInstitutionStaffRequestModal"
      >
        <v-icon>fa-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card v-if="!laborer">
      <WBDPageInstitutionStaffListFilter :institution-staff-filter-set="institutionStaffFilterSet" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="getActiveFilterNumber > 0"
          class="mr-1"
          text
          color="warning"
          @click="resetFilterSet"
        >
          {{ `Очистить` }}
        </v-btn>
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="requestList(1, options.itemsPerPage)"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card-actions v-if="!loading && !laborer">
      <v-spacer />
      <v-btn
        text
        color="warning"
      >
        <span> {{ searchResultLabel }} </span>
      </v-btn>
    </v-card-actions>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="paginatorTotal"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.statusRu="{ item }">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ item.statusRu }}</v-list-item-title>
            <v-list-item-subtitle v-if="item.error">
              {{ item.error }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <span />
      </template>
      <template v-slot:item.username="{ item }">
        <span :class="item.deletedAt ? 'red--text': undefined">{{ item.username }}</span>
        <v-btn
          v-if="item.userData && item.userData.id"
          text
          color="info"
          target="_blank"
          :to="
            {
              name: laborerProfileRouteName,
              params: { id: item.userData.id },
            }"
        >
          <span :class="item.deletedAt ? 'red--text': undefined">
            Профиль
          </span>
        </v-btn>
      </template>
      <template v-slot:item.organization="{ item }">
        <v-btn
          v-if="item.userData && item.userData.id"
          text
          color="info"
          @click="gotoOrganizationView(item)"
        >
          <span
            style="text-transform: none"
            :class="item.deletedAt ? 'red--text': undefined"
          >
            {{ item.organization.title }}</span>
        </v-btn>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          v-if="!item.deletedAt"
          icon
          small
          color="success"
          title="Удалить со списка"
          class="mr-1"
          @click="deleteMember(item)"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
        <span
          v-else
          class="red--text"
        >Удален</span>
        <WBDConfirmActionModalBtn
          v-if="canForceUpdate(item)"
          ref="confirmActionModalBtnRef"
          :title="getConfirmModalTitle()"
          :message="confirmModalMessage()"
          is-icon
          :small="false"
          :outlined="false"
          :rounded="false"
          :color="'warning'"
          :btn-icon="'mdi-refresh'"
          @onConfirmModalCancelCallback="onConfirmModalCancelCallback()"
          @onConfirmModalSuccessCallback="onConfirmModalSuccessCallback(item)"
        />
        <v-btn
          v-else-if="canCheckStatus(item)"
          icon
          small
          color="success"
          title="Проверить статус повторно"
          class="mr-1"
          @click="checkStatus(item)"
        >
          <v-icon color="error">
            mdi-refresh
          </v-icon>
        </v-btn>
        <v-btn
          v-if="canReInvite(item)"
          icon
          class="mr-1"
          small
          color="success"
          title="Приглашать повторно"
          @click="reInvite(item)"
        >
          <v-icon color="error">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <InstitutionStaffRequestModal
      v-if="officeStaffFormEnabled"
      :display-self="officeStaffFormEnabled"
      :save-callback="reload"
      :organizationId="getOrganizationId"
      @onCloseInstitutionStaffRequestModal="onCloseInstitutionStaffRequestModal"
    />
  </div>
</template>
<script>

import InstitutionStaffRequestModal from '@/components/common/institutionStaff/create'
import WBDPageInstitutionStaffListFilter from '@/components/common/filter/page-institue-staff-list-filter'
import ListMixin from '@/mixins/list-mixin'
import { pluriaizeRows } from '@/utils/plural-util'
import { formatDate } from '@/utils/date-util'
import {
  getStaffRequestStatusLabel,
  staffRequestCanReInvite,
  // STAFF_REQUEST_STATUS_SELECT_OPTIONS,
  staffRequestHasConflict
} from '@/utils/staff-request-status-util'
import { LABORER_PERSONAL_VIEW_DATA_NAME } from '@/router/laborer-personal-data'
import routeList from '@/router/labels'

export const STAFF_REQUEST_STATUS_CREATED = 'created'
export const STAFF_REQUEST_STATUS_CANCELED = 'canceled'
export const STAFF_REQUEST_STATUS_DONE = 'done'
export const STAFF_REQUEST_STATUS_SENT = 'sent'
export const STAFF_REQUEST_STATUS_WORKER_TYPE_CONFLICT = 'worker-type-conflict'

export default {
  name: 'WBDInstitutionStaffManager',
  components: {
    InstitutionStaffRequestModal,
    WBDPageInstitutionStaffListFilter,
  },
  mixins: [ListMixin],
  props: {
    showAddBtn: {
      type: Boolean
    },
    office: {
      type: Object
    },
    user: {
      type: Object
    },
    laborer: {
      type: Object
    },
  },
  data: () => ({
    laborerProfileRouteName: LABORER_PERSONAL_VIEW_DATA_NAME,
    institutionStaffFilterSet: {
      searchQuery: null,
      workflowState: null,
    },
    paginatorTotal: 0,
    loading: true,
    modelList: [],
    officeStaffFormEnabled: false,
    options: {},
    // "id" => $object->getId(),
    // "status" => $object->getStatus(),
    // "username" => $object->getUsername(),
    // "workerType" => $object->getWorkerType(),
    // "userData" => $userData,
    // "organizationData" => $organizationData,
    // "officeData" => $officeData,
    headers: [
      {
        text: 'создан',
        align: 'left',
        sortable: false,
        value: 'dateString',
      },
      {
        text: 'Организация',
        align: 'left',
        sortable: false,
        value: 'organization',
      },
      {
        text: 'Номер телефона',
        align: 'left',
        sortable: false,
        value: 'username',
      },
      {
        text: 'Статус приглашения',
        align: 'left',
        sortable: false,
        value: 'statusRu',
      },
      {
        text: 'Источник',
        align: 'left',
        sortable: false,
        value: 'source',
      },
      { text: '', value: 'options' },
    ],
  }),
  computed: {
    getOrganizationId () {
      return this.$route.params.id
    },
    searchResultLabel () {
      return `Найдено: ${this.paginatorTotal} ${pluriaizeRows(this.paginatorTotal)}`
    },
    getModel () {
      const { office } = this.institutionStaffFilterSet
      let model
      if (office) {
        model = office
      }

      return model
    },
    getActiveFilterNumber () {
      const params = {
        ...this.institutionStaffFilterSet
      }
      for (const [key, value] of Object.entries(params)) {
        if (!(value || (!value && (value === '0' || value === 0)))) {
          delete params[key]
        }
      }
      return Object.keys(params).length
    },
  },
  watch: {
    options: {
      handler () {
        this.requestList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async  created () {
    if (this.laborer) {
      this.institutionStaffFilterSet.searchQuery = this.laborer.username
    }
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
    }
  },
  methods: {
    canCheckStatus (item) {
      return !item.deletedAt && staffRequestHasConflict(item)
    },
    canForceUpdate (item) {
      return !item.deletedAt && this.canCheckStatus(item) && !!item.canForce
    },
    canReInvite (item) {
      return !item.deletedAt && staffRequestCanReInvite(item)
    },
    async requestList (page, size) {
      this.showPageLoader()
      try {
        this.loading = true
        this.modelList = []
        const params = {
          'page[number]': page || this.options.page,
          'page[size]': size || this.options.itemsPerPage
        }

        if (this.laborer) {

        } else {
          params['organization[id]'] = this.getOrganizationId
        }
        const { searchQuery } = this.institutionStaffFilterSet

        if (searchQuery && searchQuery.trim().length) {
          params.searchQuery = searchQuery
        }

        const response = await this.$store.dispatch(
          'organization/getStaffRequestList',
          { params }
        )
        this.modelList = response.data.map((item) => ({
          ...item,
          dateString: formatDate(item.createdAt),
          statusRu: getStaffRequestStatusLabel(item.status)
        }))

        if (response.headers['x-total-count']) {
          this.paginatorTotal = parseInt(response.headers['x-total-count'], 10)
        } else {
          this.paginatorTotal = this.footerProps.itemsPerPageOptions[1]
        }

        this.loading = false
        this.hidePageLoader()
      } catch (error) {
        console.log(error)
        this.loading = false
        this.hidePageLoader()
      }
    },

    async checkStatus (item, reinvitation) {
      try {
        this.showPageLoader()

        const response = await this.$store.dispatch(
          'organization/checkInstitutionStaffStatus',
          { id: item.id, forceStatus: !!item.canForce }
        )
        this.hidePageLoader()

        if (reinvitation) {
          this.showSuccessNotification('Смс повторно отправлено!', 'success')
        } else {
          if (response.data && response.data.description) {
            const desc = response.data.description
            if (desc !== 'done') {
              this.showWarningNotification('Соискатель все еще не соответствует параметрам', 'warning')
            } else {
              this.showSuccessNotification('Пользователь успешно добавлен в список!', 'success')
            }
          }
        }

        await this.requestList(1, this.options.itemsPerPage)
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
        this.showErrorNotification('Не удалось проверить статус пользователя', 'error')
      }
    },
    async deleteMember (item) {
      try {
        this.showPageLoader()

        const response = await this.$store.dispatch(
          'organization/deleteStaffRequest',
          { id: item.id }
        )

        if (response.data && response.data.description) {
          const responseDescription = response.data.description
          if (responseDescription === 'laborer-onboarded') {
            this.showErrorNotification('' +
                'Не удалось удалить соискатель со списка так как у него запланированная смена в данной организации!'
            )
          }
        } else {
          this.showSuccessNotification('Пользователь успешно удален со списка!')
        }

        this.hidePageLoader()

        await this.requestList(1, this.options.itemsPerPage)
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
        this.showErrorNotification('Не удалось удалить пользователя со списка', 'error')
      }
    },

    async reload () {
      await this.requestList(1, this.options.itemsPerPage)
    },
    async reInvite (item) {
      await this.checkStatus(item, true)
    },
    onCloseInstitutionStaffRequestModal () {
      this.officeStaffFormEnabled = false
    },
    onEnableInstitutionStaffRequestModal () {
      this.officeStaffFormEnabled = true
    },
    onInviteUser () {
      this.officeStaffFormEnabled = false
    },
    async resetFilterSet () {
      this.institutionStaffFilterSet = {
        searchQuery: null,
        workflowState: null,
      }

      this.eventsBus.$emit(this.eventNames.PAGE_INSTITUTION_STAFF_LIST_FILTER_RESET)
    },
    confirmModalMessage (action) {
      return 'Соискатель, которого вы пытаетесь добавить в список для своих, является самозанятым. При добавлении ' +
          'в список для своих соискатель будет переведен в режим работы ФЛ. Вы согласны?'
    },
    getConfirmModalTitle (action) {
      return 'Изменение режима'
    },
    onConfirmModalCancelCallback (item, action) {
    },
    onConfirmModalSuccessCallback (item) {
      this.checkStatus(item, null)
      const confirmActionModalBtnRef = this.$refs.confirmActionModalBtnRef
      if (confirmActionModalBtnRef) {
        confirmActionModalBtnRef.disableModal()
      }
    },
    gotoOrganizationView (item) {
      const routeData = this.$router.resolve(
        { name: routeList.ORGANIZATION_VIEW_ROUTE_NAME, params: { id: item.organization.id } }
      )
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

